/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-restricted-syntax */
/* eslint-disable react/destructuring-assignment */
import { ActionIcon, Group, OptionsFilter, Select } from '@mantine/core';
import { showNotification } from '@mantine/notifications';
import { IconRecycle, IconRefresh } from '@tabler/icons-react';
import { useEffect, useState } from 'react';
import { ProposalResidueType } from '../../../models/core/proposals.type';
import proposalsService from '../../../services/core/proposals.service';
import theme from '../../../theme';
import { SessionStorageKey } from '../../../utils/constants.utils';
import { transformComboBoxGroupDataFromV5toV7 } from '../../../utils/mantine.utils';
import ProfileCardLink from '../ProfileCardLink/ProfileCardLink';

type FormViewProps = {
  idProposta: number;
  label: string;
  formItem: any;
  idsToBeDisabled: number[];
  disabled: boolean;
  callback(item: ProposalResidueType | null): void;
  zIndex: number;
  useCache: boolean;
};

export default function ProposalResiduePicker(props: FormViewProps) {
  const [data, setData] = useState<ProposalResidueType[]>([]);
  const [loading, setLoading] = useState(false);

  const confirmActionResult = (item: ProposalResidueType | null, confirmed: boolean) => {
    if (!confirmed) {
      return;
    }
    props.callback(item);
  };

  const loadData = async () => {
    try {
      setLoading(true);
      const result = await proposalsService.listResidues({
        idProposta: props.idProposta,
        cache: props.useCache,
      });
      setData(result);
      sessionStorage.setItem(
        `${SessionStorageKey.ProposalResidueList}_${props.idProposta}`,
        JSON.stringify(result)
      );
    } catch (error: any) {
      showNotification({
        title: `Proposta - Resíduos`,
        message: error?.isBusinessException
          ? error.description
          : 'Não foi possível listar os resíduos dessa proposta.',
        color: 'red',
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (props.useCache) {
      const cacheResult = JSON.parse(
        sessionStorage.getItem(`${SessionStorageKey.ProposalResidueList}_${props.idProposta}`) || '[]'
      ) as ProposalResidueType[];

      if (cacheResult.length > 0) {
        setData(cacheResult);
      } else {
        loadData();
      }
    } else {
      loadData();
    }
  }, []);

  const handleRefresh = () => {
    loadData();
  };

  const optionsFilter: OptionsFilter = ({ options, search }) => {
    if (search.trim().length === 0) {
      return options;
    }

    const filteredData = data
      .filter((x) => {
        const value = `${x.idPropostaResiduo}|${x.idResiduo}|${x.residuoCliente}|${x.residuo}|${
          x.codigoIBAMA || ''
        }`;
        return value.toLowerCase().includes(search.toLowerCase());
      })
      .map((y) => y.idPropostaResiduo?.toString());

    const filteredOptions = [];
    for (const option of options) {
      const items = (option as any).items.filter((x: any) => filteredData.includes(x.value));
      if (items.length > 0) {
        filteredOptions.push({
          ...option,
          items,
        });
      }
    }
    return filteredOptions;
  };

  return (
    <Group grow preventGrowOverflow={false} wrap="nowrap">
      <Select
        key={`proposal-residue-picker_${props.formItem.value?.toString()}`}
        leftSection={<IconRecycle size={15} />}
        label={props.label}
        placeholder="Selecione..."
        data={transformComboBoxGroupDataFromV5toV7(
          data.map((x) => {
            return {
              label: `# ${x.idPropostaResiduo} - ${x.residuoCliente}`,
              value: x.idPropostaResiduo!.toString(),
              disabled: props.idsToBeDisabled.includes(x.idPropostaResiduo!),
              group: x.residuoCliente.toUpperCase()[0],
            };
          })
        ).sort((a, b) => a.group.localeCompare(b.group))}
        clearable
        searchable
        filter={optionsFilter}
        disabled={props.disabled || loading}
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        renderOption={({ option, checked }) => {
          const row = data.find((x) => x.idPropostaResiduo!.toString() === option.value)!;
          return (
            <ProfileCardLink
              id={row.idResiduo.toString()}
              name={row.residuoCliente}
              nameSize="sm"
              description={`Código IBAMA: ${row.codigoIBAMA || '-'} | Perigoso: ${
                row.residuoClientePerigoso ? 'Sim' : 'Não'
              }`}
              descriptionSize="xs"
              linkPrefix="residues"
              showLink={false}
            />
          );
        }}
        required
        {...props.formItem}
        value={props.formItem.value?.toString()}
        onOptionSubmit={(value: string) => {
          confirmActionResult(data.find((x) => x.idPropostaResiduo!.toString() === value) || null, true);
        }}
        comboboxProps={{ zIndex: props.zIndex + 1 }}
      />
      <ActionIcon
        style={{ marginLeft: -10, marginTop: 20, maxWidth: 15 }}
        radius="sm"
        color="primary"
        variant="outline"
        onClick={handleRefresh}
        disabled={props.disabled || loading}
        loading={loading}
      >
        <IconRefresh size={15} color={theme?.colors?.primary?.[6]} />
      </ActionIcon>
    </Group>
  );
}
